export const plural = ({ one, other }: { one: string; other: string }, x?: number): string =>
  x === 1 ? one : other;
